import { formatEventDate } from '../../../shared/formattingUtils';

export const buildPromoCodesFilterGroups = (filterOptions = {}) => [
  {
    id: 'promo_details',
    label: 'Promo Details',
    filters: [
      {
        id: 'type',
        label: 'Type',
        type: 'checkbox',
        options: (filterOptions.type_options || []).map((opt) => ({
          value: opt.value,
          label: opt.label,
        })),
      },
      {
        id: 'status',
        label: 'Status',
        type: 'checkbox',
        options: [
          { value: 'active', label: 'Active' },
          { value: 'expired', label: 'Expired' },
          { value: 'upcoming', label: 'Upcoming' },
        ],
      },
    ],
  },
  {
    id: 'location',
    label: 'Venue',
    filters: [
      {
        id: 'event',
        label: 'Event',
        type: 'search',
        options: (filterOptions.event_options || []).map((opt) => ({
          value: String(opt.value),
          label: opt.event_date ? `${opt.label} \u00B7 ${formatEventDate(opt.event_date)}` : opt.label,
        })),
      },
      ...(filterOptions.class_options ? [{
        id: 'class',
        label: 'Class',
        type: 'search',
        options: filterOptions.class_options.map((opt) => ({
          value: String(opt.value),
          label: opt.label,
        })),
      }] : []),
      {
        id: 'venue',
        label: 'Venue',
        type: 'checkbox',
        options: (filterOptions.venue_options || []).map((opt) => ({
          value: String(opt.value),
          label: opt.label,
        })),
      },
    ],
  },
];
